import { GameEndedModal } from '@components/game/gameEndedModal/GameEndedModal';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import ImagePreloader from '@components/helpers/ImagePreloader';
import { InvitedModal } from '@components/lobby/InvitedModal';
import { SmallLobby } from '@components/lobby/SmallLobby';
import { Arsenal } from '@components/arsenal/Arsenal';
import { initMobileAppBus } from '@helpers/mobileApp';
import { Background } from '@components/Background';
import { Navigation } from '@components/Navigation';
import { Combat } from '@components/game/Combat';
import { Sound } from '@components/sound/Sound';
import { ToastContainer } from 'react-toastify';
import { Lobby } from '@components/lobby/Lobby';
import { Chat } from '@components/chat/Chat';
import { Navbar } from '@components/Navbar';
import { Loader } from '@components/Loader';
import { Hub } from '@components/hub/Hub';
import { useAppStore } from '@stores';
import { useEffect } from 'react';
import '@api/websocket';
// @ts-ignore
import '@fontsource/chakra-petch';
// @ts-ignore
import '@fontsource-variable/kode-mono';

export const queryClient = new QueryClient();

export default function App() {
  const { tab } = useAppStore();

  const showSmallLobby = ['navigation', 'lobby'].includes(tab);

  useEffect(() => {
    initMobileAppBus();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="font-space user-select-none">
        <div className="h-screen overflow-hidden relative">
          <ToastContainer closeOnClick />
          <ImagePreloader />
          <GameEndedModal />
          <InvitedModal />
          <Background />
          <Loader />
          <Sound />

          <div className="absolute inset-0 flex flex-col border-t border-secondary">
            {tab !== 'combat' && (
              <div className="flex-1 flex overflow-hidden">
                {showSmallLobby && <SmallLobby />}
                <div className="flex-1">
                  {tab === 'hub' && <Hub />}
                  {tab === 'chat' && <Chat />}
                  {tab === 'lobby' && <Lobby />}
                  {tab === 'arsenal' && <Arsenal />}
                  {tab === 'navigation' && <Navigation />}
                </div>
              </div>
            )}
            {tab === 'combat' && <Combat />}

            <Navbar />
          </div>
        </div>
      </div>
    </QueryClientProvider>
  );
}